import { useAppContext } from '../../../context/app-context/app-context';
import { setIsToasterOpen } from '../../../context/app-context/app-context-actions';
import { useDataContext } from '../../../context/data-context/use-data-context';
import { isLoggedIn } from '../../../utils/login';
import { getAddressBookAddresses } from '../mutations/get-address-book-addresses';
import { saveAddressBookAddress } from '../mutations/save-address-book-address';
import { ToastVariants } from '@dotcom/crown-ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const addressOptions = {
  getAddressBookAddresses,
  saveAddressBookAddress,
};

export const useAddressBookAddresses = () => {
  const { t } = useTranslation();
  const { setSavedContacts } = useDataContext();
  const { appDispatch } = useAppContext();
  const queryClient = useQueryClient();
  const userIsLoggedIn = isLoggedIn();

  const addressBookAddresses = useQuery({
    ...addressOptions.getAddressBookAddresses({
      onError: (error) => {
        setIsToasterOpen(appDispatch, {
          variant: ToastVariants.Error,
          title: t('addressView.failedToast'),
          children: error.message ?? t('addressView.failedToast'),
        });
      },
    }),
    enabled: userIsLoggedIn,
    refetchOnWindowFocus: false,
  });

  const saveAddressToAddressBook = useMutation(
    addressOptions.saveAddressBookAddress({
      onSuccess: () => {
        queryClient.invalidateQueries(addressOptions.getAddressBookAddresses());
      },
      onError: (error) => {
        setIsToasterOpen(appDispatch, {
          variant: ToastVariants.Error,
          title: t('addressView.failedToast'),
          children: t('addressView.quickAddressError') || error.message,
        });
      },
    }),
  );

  useEffect(() => {
    // this ensures we update the saved contacts when the query is triggered
    // and the data is updated even when the delete action is triggered
    if (addressBookAddresses.isSuccess) {
      setSavedContacts(addressBookAddresses.data?.contacts || []);
    }
  }, [addressBookAddresses.data, setSavedContacts]);

  return { addressBookAddresses, saveAddressToAddressBook };
};
